import { SMC } from '../Components.js';
import PointType from '../PointType.js';
import Spell from '../Spell.js';

import AreaOfEffects from '../../Actions/AreaOfEffects.js';
import Durations from '../../Actions/Durations.js';
import Effects from '../../Actions/Effects.js';
import Ranges from '../../Actions/Ranges.js';
import Times from '../../Actions/Times.js';
import ToHits from '../../Actions/ToHits.js';
import Utilities from '../../Actions/Utilities.js';

export default new Spell(
  'Friends',
  0,
  PointType.SpellSlot,
  [
    'For the duration, you have advantage on all Charisma checks directed at one creature of your choice that isn’t hostile toward you. When the spell ends, the creature realizes that you used magic to influence its mood and becomes hostile toward you. A creature prone to violence might attack you. Another creature might seek retribution in other ways (at the DM’s discretion), depending on the nature of your interaction with it.',
  ],
  Utilities.NonCombat,
  Times.Action,
  Durations.Minutes(1),
  Ranges.Self,
  AreaOfEffects.SingleTarget,
  ToHits.AlwaysWorks,
  Effects.Buff(),
  SMC('a small amount of makeup applied tot he face as the spell is cast'),
  'Enchantment'
);
